import SliderInput from './components/formElements/SliderInput';
import TextInput from './components/formElements/TextInput';
import TextAreaInput from './components/formElements/TextAreaInput';
import DatePickerInput from './components/formElements/DatePickerInput';
import ToggleInput from './components/formElements/ToggleInput';
import HTML from './components/formElements/HTML';

export default {
  SliderInput,
  TextInput,
  TextAreaInput,
  DatePickerInput,
  ToggleInput,
  HTML,
};



// WEBPACK FOOTER //
// ./src/formTypes.js